import { APISettings } from "../../../../../config/ApiSettings";
import saveAs from "file-saver";
import { chapterHistoryApi } from "../../../../../utilities/api/chapterHistoryApi";
import { useState } from "react";
import { useAppSelector } from "../../../../../app/hooks";
import { RecordStatus } from "../../../../../utilities/interfaces/RecordStatus";

export const useChapterHistoryTableController = (chapter: any, reloadChapterHistory: any) => {
    const baseUrl = new APISettings().getApiURL();
    const recordStatuses: RecordStatus[] = useAppSelector((state) => state.recordStatuses.recordStatuses);
    const downloadPdf = async (containerName: string, blobName: string) => {
        let url = `${baseUrl}/fileStorage/GetAsByteArray/${containerName}/${blobName}`;
        let blob: Blob = await fetch(url).then((r) => r.blob());

        saveAs(blob, blobName);
    }

    const deleteHistoryItem = async (chapterHistoryId: string) => {
        await chapterHistoryApi.delete(chapterHistoryId);
    }

    const [pendingDeleteId, setPendingDeleteId] = useState<string | null>(null);

    const handleDeleteConfirm = async () => {
        if (pendingDeleteId === null) return;
        await deleteHistoryItem(pendingDeleteId);
        setPendingDeleteId(null);
        reloadChapterHistory();
    };


    return{
        pendingDeleteId,
        recordStatuses,
        // Functions
        downloadPdf,
        handleDeleteConfirm,
        setPendingDeleteId
    };
}